import React, { useEffect } from 'react';

import { Sampling } from 'src/shared/types/sampling';

import { addToast } from 'src/shared/components/ui';
import {
  ButtonV2,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader
} from 'src/shared/components/ui';

import { useSamplingEditForm } from '../../hooks/useSamplingEditForm';
import { useUpdateSampling } from '../../hooks/useUpdateSampling';

interface SamplingEditModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  sampling: Sampling;
  setSelectedSampling: (sampling: Sampling) => void;
}
const SamplingEditModal: React.FC<SamplingEditModalProps> = ({
  isOpen,
  onOpenChange,
  sampling,
  setSelectedSampling
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useSamplingEditForm({ name: sampling?.name });

  const samplingMutation = useUpdateSampling();

  useEffect(() => {
    if (sampling) {
      reset({
        name: sampling?.name || ''
      });
    }
  }, [sampling, reset]);

  const onSubmit = (data: any) => {
    samplingMutation.mutate(
      {
        ...data,
        id: sampling?.id,
        productId: sampling?.product_quote?.product?.id
      },
      {
        onSuccess: (data: Sampling) => {
          setSelectedSampling(data);
          onOpenChange(false);
          addToast({
            color: 'success',
            title: 'Sample updated successfully.'
          });
        }
      }
    );
  };

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1 p-5 border-b border-gray-4">
              Edit sampling
            </ModalHeader>
            <ModalBody className="p-5 flex flex-col gap-5">
              <form id="organization-form" onSubmit={handleSubmit(onSubmit)}>
                <Input
                  label="Name"
                  errorMessage={errors.name?.message}
                  isInvalid={!!errors.name}
                  {...register('name')}
                />
              </form>
            </ModalBody>
            <ModalFooter className="justify-start border-t border-gray-4 p-5">
              <ButtonV2
                form="organization-form"
                type="submit"
                isDisabled={samplingMutation.isPending}
                isLoading={samplingMutation.isPending}
              >
                Save
              </ButtonV2>
              <ButtonV2
                color="default"
                variant="flat"
                onPress={() => onClose()}
                isDisabled={samplingMutation.isPending}
              >
                Close
              </ButtonV2>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default SamplingEditModal;
